// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"styles_sharedStyles__4OrP5"};